export { CLIENT_MANAGEMENT_GUIDE } from './clientManagementGuide';
export { SESSION_GENERATION_GUIDE } from './sessionGenerationGuide';
export { CREDIT_SYSTEM_GUIDE } from './creditSystemGuide';
export { ORGANIZATION_SESSIONS_GUIDE } from './organizationSessionsGuide';
export { ROLES_PERMISSIONS_GUIDE } from './rolesPermissionsGuide';
export { ORGANIZATION_ADMIN_GUIDE } from './organizationAdminGuide';

export interface PractitionerGuide {
  id: string;
  title: string;
  icon: string;
  content: string;
  description: string;
}

import { CLIENT_MANAGEMENT_GUIDE } from './clientManagementGuide';
import { SESSION_GENERATION_GUIDE } from './sessionGenerationGuide';
import { CREDIT_SYSTEM_GUIDE } from './creditSystemGuide';
import { ORGANIZATION_SESSIONS_GUIDE } from './organizationSessionsGuide';
import { ROLES_PERMISSIONS_GUIDE } from './rolesPermissionsGuide';
import { ORGANIZATION_ADMIN_GUIDE } from './organizationAdminGuide';

export const PRACTITIONER_GUIDES: PractitionerGuide[] = [
  {
    id: 'client-management',
    title: 'Client Management',
    icon: 'Users',
    content: CLIENT_MANAGEMENT_GUIDE,
    description: 'Learn how to add, manage, and work with your clients effectively',
  },
  {
    id: 'session-generation',
    title: 'Session Generation',
    icon: 'Sparkles',
    content: SESSION_GENERATION_GUIDE,
    description: 'Master the art of creating personalized sessions for clients',
  },
  {
    id: 'credits',
    title: 'Credits & Billing',
    icon: 'CreditCard',
    content: CREDIT_SYSTEM_GUIDE,
    description: 'Understand how credits work and manage your billing',
  },
  {
    id: 'organization-sessions',
    title: 'Organization Sessions',
    icon: 'Building2',
    content: ORGANIZATION_SESSIONS_GUIDE,
    description: 'Create and manage sessions for teams and organizations',
  },
  {
    id: 'organization-admin',
    title: 'Organization Admin',
    icon: 'Settings2',
    content: ORGANIZATION_ADMIN_GUIDE,
    description: 'Complete guide for organization administrators',
  },
  {
    id: 'roles-permissions',
    title: 'Roles & Permissions',
    icon: 'Shield',
    content: ROLES_PERMISSIONS_GUIDE,
    description: 'Understand role capabilities and access levels',
  },
];
